import { render } from "./SimpleModal.vue?vue&type=template&id=7ef8de68&scoped=true&ts=true"
import script from "./SimpleModal.vue?vue&type=script&lang=ts"
export * from "./SimpleModal.vue?vue&type=script&lang=ts"

import "./SimpleModal.vue?vue&type=style&index=0&id=7ef8de68&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef8de68"]])

export default __exports__